import { render, staticRenderFns } from "./feature-toggle.vue?vue&type=template&id=6a5f979e&functional=true"
import script from "./feature-toggle.vue?vue&type=script&lang=js"
export * from "./feature-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports